function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import merge from 'lodash/merge';
import { highlightXAxisLabel, legend, mergeOptions, tooltip, xAxis, yAxis } from '../utils/commons';
import Chart from '../chart';
import './css/line.css';
import mergeRefs from 'react-merge-refs';
var lineOptions = _ref => {
  var {
    chartRef,
    legendEnabled,
    theme,
    tickRef
  } = _ref;
  return {
    chart: {
      type: 'line',
      spacing: [50, 20, 20, 20]
    },
    legend: legend({
      group: legendEnabled,
      theme
    }),
    plotOptions: {
      series: {
        label: {
          connectorAllowed: false
        }
      },
      line: _objectSpread(_objectSpread({}, highlightXAxisLabel({
        theme,
        chartRef,
        tickRef
      })), {}, {
        marker: {
          symbol: 'circle',
          lineColor: undefined,
          states: {
            hover: {
              fillColor: theme.palette.background.container,
              lineWidth: 5,
              radiusPlus: 1
            }
          }
        },
        states: {
          hover: {
            halo: {
              attributes: undefined,
              opacity: 0,
              size: 0
            }
          }
        }
      })
    },
    subtitle: {
      text: undefined
    },
    title: {
      text: undefined
    },
    tooltip: merge(tooltip({
      theme
    }), {
      tooltip: {
        pointFormat: "{point.y}"
      }
    }),
    xAxis: merge(xAxis({
      theme
    }), {
      lineWidth: 0,
      crosshair: {
        snap: true,
        width: 2,
        color: theme.colorChartCrosshair
      }
    }),
    yAxis: merge(yAxis({
      theme
    }), {
      title: {
        margin: 14
      }
    })
  };
};
var Line = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
    options,
    theme
  } = _ref2;
  var chartRef = React.useRef(null);
  var tickRef = React.useRef(null);
  var handleRef = mergeRefs([ref, chartRef]);
  var chartOptions = React.useMemo(() => {
    var _options$legend;
    var legendEnabled = options === null || options === void 0 || (_options$legend = options.legend) === null || _options$legend === void 0 ? void 0 : _options$legend.enabled;
    return mergeOptions(lineOptions({
      chartRef,
      legendEnabled,
      theme,
      tickRef
    }), options);
  }, [options, theme]);
  return /*#__PURE__*/React.createElement(Chart, {
    immutable: true,
    options: chartOptions,
    ref: handleRef,
    theme: theme
  });
});
Line.displayName = 'Line';
export default Line;